// extracted by mini-css-extract-plugin
export default {"templateBox":"TemplateBox_templateBox__ifC9Z","templateBox__items":"TemplateBox_templateBox__items__jzRQY","isTicket":"TemplateBox_isTicket__2Iilb"};